<header class="event-header section-inset-t">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-5"><ng-content select="[slot=breadcrumbs]"></ng-content></div>
        <h1 class="text-secondary h2">{{ event.title }}</h1>

        <strong *ngIf="event.subtitle">{{ event.subtitle }}</strong>

        <section class="mb-3 mt-4">
          <ul class="meta-list" *ngIf="event?.themes?.length">
            <li *ngFor="let theme of event.themes; let i = index" [class.me-3]="i === (event.themes?.length || 0) - 1">
              <a [routerLink]="['/thema', theme.slug]" class="button button-icon button--light">
                <app-icon class="icon-xs" [anchor]="theme.icon || 'icon-idea'" [attr.aria-label]="theme.title"></app-icon>
              </a>
            </li>
          </ul>
        </section>
      </div>
      <div class="col-md-6 event-header__figure-wrapper">
        <figure class="event-header__figure" *ngIf="event.image && event.image.url">
          <div class="event-meta-bar">
            <div class="event-meta-bar__date">
              <em class="event-date">
                <span class="event-date__day">{{ event.start | date : 'dd' }}</span>
                <span class="event-date__month">{{ getMonth(event.start || '') }}</span>
              </em>

              <span class="type-body-xxs event-date--end__label">tot</span>

              <em class="event-date event-date--end" *ngIf="event.end && (event.end | date : 'dd') !== (event.start | date : 'dd')">
                <span class="event-date__day">{{ event.end | date : 'dd' }}</span>
                <span class="event-date__month">{{ getMonth(event.end) }}</span>
              </em>
            </div>

            <div *ngIf="event.startTime || event.endTime">
              <span class="chip chip--primary d-block mx-auto mb-2">
                <app-icon anchor="icon-clock"></app-icon>
              </span>
              <span *ngIf="event.startTime" class="d-inline-block fs-body-xs">
                {{ event.startTime }}
                <ng-container *ngIf="event.endTime">-&nbsp;</ng-container>
              </span>
              <span class="fs-body-xs" *ngIf="event.endTime">{{ event.endTime }}</span>
            </div>

            <div *ngIf="(event.dateSpans?.length || 0) > 1">
              <span class="chip chip--primary d-block mx-auto mb-2">
                <app-icon anchor="icon-calendar"></app-icon>
              </span>

              <a [routerLink]="[]" fragment="data" class="text-break fw-bold fs-body-xs">
                Meerdere
                <br />
                data
              </a>
            </div>

            <div *ngIf="event.locations?.length || event.entireArea">
              <a
                *ngIf="event.locations?.length === 1"
                class="block-link"
                [href]="
                  event.entireArea
                    ? 'https://www.google.com/maps/place/IJssel/@52.2733711,5.6986093'
                    : 'https://www.google.com/maps/search/' + event.locations?.[0]?.lat + ',' + event.locations?.[0]?.lng
                "
                aria-label="bekijk locatie op google maps"
                target="_blank"
              >
                <span class="chip chip--primary d-block mx-auto mb-2"><app-icon anchor="icon-map-marker"></app-icon></span>
                <span class="text-break fw-bold fs-body-xs">
                  <ng-container *ngIf="!event.entireArea">
                    {{ event.locations?.[0]?.label || ('bekijk-op-kaart' | fromDictionary) }}
                  </ng-container>
                  <ng-container *ngIf="event.entireArea">{{ 'gehele-ijssel' | fromDictionary }}</ng-container>
                </span>
              </a>
              <a *ngIf="(event.locations?.length || 0) > 1" class="block-link" [routerLink]="['.']" fragment="praktische-informatie">
                <span class="chip chip--primary d-block mx-auto mb-2">
                  <app-icon anchor="icon-map-marker"></app-icon>
                </span>

                <span class="text-break fs-body-xs">{{ 'bekijk-locaties' | fromDictionary }}</span>
              </a>
            </div>
          </div>

          <!--<div>-->
          <!--<em class="event-date event-date--sm event-date--chip d-sm-none">
              <span class="event-date__day">{{ event.start | date : 'd' }}</span>
              <span class="event-date__month">{{ getMonth(event.start) }}</span>
            </em>-->

          <div class="event-header-image-tile">
            <div class="event-header-image-tile__inner">
              <app-image
                class="event-header-image-tile__image"
                [imageSizes]="[900, 1400, 1800]"
                [alt]="event.image.alt ?? event.title"
                [image]="event.image"
                [sizes]="{ xs: 12, md: 6 }"
                [objectFitMode]="true"
                [height]="500"
                [width]="500"
              ></app-image>
              <figcaption *ngIf="event.image.caption" class="event-header-image-tile__caption type-body-xs">
                &copy; {{ ('foto-credits-prefix' | fromDictionary) + event.image.caption }}
              </figcaption>
            </div>
          </div>
          <!--</div>-->
        </figure>
      </div>
    </div>
  </div>

  <app-bg-wave
    class="event-header__background"
    [autoPlay]="true"
    [startPos]="'12s'"
    [bgColor]="'var(--bs-light)'"
    [strokeColor]="'var(--bs-secondary)'"
  ></app-bg-wave>
</header>
